import React from 'react'

export default function Services() {
  return (
    <section id="services" classNameName="service-section">
    <h1 className="service-heading">Services</h1>
    <div className="service--grid-container">
      <div className="service-grid">
        <i className="fa-solid fa-desktop fa-3x service-icon"></i>
        <h2>Front-end Website Creation</h2>
        <p>
          Development of eye-pleasing professional front-end of the
          websites, blogs and stores etc.
        </p>
      </div>

      <div className="service-grid">
        <i className="fa-solid fa-mobile-screen-button fa-3x service-icon"></i>
        <h2>Responsive Sites</h2>
        <p>
          Creation of responsive sites for the best viewing at all
          resolutions.
        </p>
      </div>

      <div className="service-grid">
        <i className="fa-brands fa-react fa-3x service-icon"></i>
        <h2>React Front-end Development</h2>
        <p>
          Creation of professional and rich UI webpages using ReactJS
          library.
        </p>
      </div>

      <div className="service-grid">
        <i className="fa-solid fa-bullhorn fa-3x service-icon"></i>
        <h2>Semantic Code</h2>
        <p>
          Strategy for your websites to appear better and better in
          searches.
        </p>
      </div>
    </div>
  </section>

  )
}